import * as actionTypes from '../types/inputOperation';

export function getOperation(payload) {
  return {
    type: actionTypes.GET_OPERATION,
    payload
  };
}

export function getOperationSuccess(payload) {
  return {
    type: actionTypes.GET_OPERATION_SUCCESS,
    payload
  };
}

export function getOperationFail(payload) {
  return {
    type: actionTypes.GET_OPERATION_FAIL,
    payload
  };
}

export function saveOperation(payload) {
  return {
    type: actionTypes.SAVE_OPERATION,
    payload
  };
}

export function saveOperationSuccess(payload) {
  return {
    type: actionTypes.SAVE_OPERATION_SUCCESS,
    payload
  };
}

export function saveOperationFail(payload) {
  return {
    type: actionTypes.SAVE_OPERATION_FAIL,
    payload
  };
}
